import { render } from "./Cursor.vue?vue&type=template&id=51855683&scoped=true"
import script from "./Cursor.vue?vue&type=script&lang=js"
export * from "./Cursor.vue?vue&type=script&lang=js"

import "./Cursor.vue?vue&type=style&index=0&id=51855683&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51855683"]])

export default __exports__